
import React from "react";
import { Search } from "lucide-react";
import { SidebarHeader, SidebarInput } from "@/components/ui/sidebar";

interface SidebarHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  totalPartsCount: number;
}

const FilterSidebarHeader = ({ searchQuery, setSearchQuery, totalPartsCount }: SidebarHeaderProps) => {
  return (
    <SidebarHeader className="flex flex-col items-start pt-4">
      {/* Search Group */}
      <div className="relative w-full px-2 mb-2">
        <Search className="absolute left-5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" />
        <SidebarInput 
          type="search" 
          placeholder="Search parts..." 
          className="pl-8 w-full" 
          value={searchQuery} 
          onChange={e => setSearchQuery(e.target.value)} 
        />
      </div>
      
      {/* Parts count */}
      <div className="px-2">
        <h2 className="text-sm font-medium text-muted-foreground">
          {totalPartsCount} {totalPartsCount === 1 ? "Part" : "Parts"} Found
        </h2>
      </div>
    </SidebarHeader>
  );
};

export default FilterSidebarHeader;
